<ul class="inspiration-items">
  <li *ngFor="let box of boxes" [class.active]="current.storage.boxId === box.id">
    <figure (click)="selectBox(box.id)">
      <span class="media">
        <img *ngIf="box.img !== ''" [src]="'assets/img/' + box.img" [alt]="box.label" />
        <span class="title-overlay">
   {{ box.label | translate }}
  </span>
        <span class="state">
          <svg class="icon-action-select-thumb" aria-hidden="true">
            <use
              xmlns:xlink="http://www.w3.org/1999/xlink"
              xlink:href="assets/img/icons.svg#icon-action-select-thumb"></use>
          </svg>
        </span>
      </span>
    </figure>
  </li>
</ul>
